var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-status"},[_c('el-tag',{attrs:{"size":"small","type":_vm.type}},[_vm._v(_vm._s(_vm.str))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }